const encryptionEnum = Object.freeze({
    SSL: 'ssl',
    TLS: 'tls'
});
export default encryptionEnum;
